(function () {
  function formatEUR(amount) {
    return amount.toFixed(2).replace('.', ',') + ' €';
  }

  function collapseOnMobile(container) {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var cards = Array.prototype.slice.call(container.children);
    var visibleCount = 6;
    if (cards.length <= visibleCount) return;
    var hidden = cards.slice(visibleCount);
    hidden.forEach(function (c) { c.hidden = true; });
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kaubox-builder__more-btn';
    btn.textContent = 'Mehr anzeigen (+' + hidden.length + ')';
    btn.addEventListener('click', function () {
      hidden.forEach(function (c) { c.hidden = false; });
      btn.remove();
    });
    container.insertAdjacentElement('afterend', btn);
  }

  function init() {
    const root = document.querySelector('[data-kaubox-builder]');
    if (!root) return;

    const catalogScript = document.querySelector('script[data-kaubox-catalog]');
    const catalog = JSON.parse(catalogScript.textContent);
    const catalogBySku = {};
    catalog.forEach((item) => (catalogBySku[item.sku] = item));

    const baseVariantId = parseInt(root.dataset.baseVariantId, 10);
    const basePrice = parseFloat(root.dataset.basePrice);
    const baseSlots = parseInt(root.dataset.baseSlots, 10);

    const normalContainer = root.querySelector('[data-group="normal"]');
    const premiumContainer = root.querySelector('[data-group="premium"]');
    const progressFill = root.querySelector('[data-progress-fill]');
    const progressText = root.querySelector('[data-progress-text]');
    const summaryList = root.querySelector('[data-summary-list]');
    const summaryEmpty = root.querySelector('[data-summary-empty]');
    const totalPriceEl = root.querySelector('[data-total-price]');
    const savingsEl = root.querySelector('[data-savings]');
    const savingsRetailEl = root.querySelector('[data-savings-retail]');
    const savingsPctEl = root.querySelector('[data-savings-pct]');
    const addBtn = root.querySelector('[data-add-to-cart]');
    const errorEl = root.querySelector('[data-error]');
    const successEl = root.querySelector('[data-success]');

    // unitLog: chronological array of sku strings, one entry per unit selected
    let unitLog = [];

    function countsBySku() {
      const counts = {};
      unitLog.forEach((sku) => (counts[sku] = (counts[sku] || 0) + 1));
      return counts;
    }

    function renderCard(item) {
      const card = document.createElement('div');
      card.className = 'kaubox-builder__card' + (item.premium ? ' kaubox-builder__card--premium' : '');
      card.dataset.sku = item.sku;
      card.setAttribute('role', 'listitem');
      const catClass = 'kaubox-builder__card-cat--' + (item.cat || 'rind');
      card.innerHTML =
        '<div class="kaubox-builder__card-info">' +
        '<span class="kaubox-builder__card-cat ' + catClass + '">' + (item.catLabel || '') + '</span>' +
        '<p class="kaubox-builder__card-name">' + item.name + '</p>' +
        '<p class="kaubox-builder__card-price">' + formatEUR(item.price) + (item.premium ? ' <span class="kaubox-builder__badge">Premium</span>' : '') + '</p>' +
        '</div>' +
        '<div class="kaubox-builder__stepper">' +
        '<button type="button" class="kaubox-builder__step-btn" data-action="minus" aria-label="Weniger ' + item.name + '">−</button>' +
        '<span class="kaubox-builder__qty" data-qty>0</span>' +
        '<button type="button" class="kaubox-builder__step-btn" data-action="plus" aria-label="Mehr ' + item.name + '">+</button>' +
        '</div>';

      card.querySelector('[data-action="plus"]').addEventListener('click', () => {
        card.hidden = false;
        unitLog.push(item.sku);
        update();
      });
      card.querySelector('[data-action="minus"]').addEventListener('click', () => {
        const idx = unitLog.lastIndexOf(item.sku);
        if (idx !== -1) unitLog.splice(idx, 1);
        update();
      });

      return card;
    }

    catalog.forEach((item) => {
      const card = renderCard(item);
      (item.premium ? premiumContainer : normalContainer).appendChild(card);
    });

    collapseOnMobile(normalContainer);
    collapseOnMobile(premiumContainer);

    function update() {
      const counts = countsBySku();

      // update qty labels on cards
      root.querySelectorAll('.kaubox-builder__card').forEach((card) => {
        const sku = card.dataset.sku;
        const qty = counts[sku] || 0;
        card.querySelector('[data-qty]').textContent = qty;
        card.classList.toggle('kaubox-builder__card--active', qty > 0);
      });

      const normalUnits = unitLog.filter((sku) => !catalogBySku[sku].premium);
      const premiumUnits = unitLog.filter((sku) => catalogBySku[sku].premium);

      const includedUnits = normalUnits.slice(0, baseSlots);
      const extraNormalUnits = normalUnits.slice(baseSlots);
      const chargedExtraUnits = extraNormalUnits.concat(premiumUnits);

      // progress bar
      const usedSlots = includedUnits.length;
      progressFill.style.width = (usedSlots / baseSlots) * 100 + '%';
      progressText.textContent = usedSlots + ' von ' + baseSlots + ' Basis-Plätzen genutzt';

      // total price
      let total = basePrice;
      chargedExtraUnits.forEach((sku) => (total += catalogBySku[sku].price));
      totalPriceEl.textContent = formatEUR(total);

      let retailTotal = 0;
      unitLog.forEach((sku) => (retailTotal += catalogBySku[sku].retail));
      const savings = retailTotal - total;
      if (unitLog.length > 0 && savings > 0.05) {
        const pct = Math.round((savings / retailTotal) * 100);
        savingsEl.hidden = false;
        savingsRetailEl.textContent = 'statt ' + formatEUR(retailTotal);
        savingsPctEl.textContent = 'Du sparst ' + formatEUR(savings) + ' (' + pct + '%)';
      } else {
        savingsEl.hidden = true;
      }

      // summary list
      summaryList.querySelectorAll('.kaubox-builder__summary-item').forEach((el) => el.remove());
      const allCounts = countsBySku();
      const skusInOrder = Object.keys(allCounts);
      if (skusInOrder.length === 0) {
        summaryEmpty.hidden = false;
      } else {
        summaryEmpty.hidden = true;
        skusInOrder.forEach((sku) => {
          const item = catalogBySku[sku];
          const qty = allCounts[sku];
          const li = document.createElement('li');
          li.className = 'kaubox-builder__summary-item';
          const includedCount = includedUnits.filter((s) => s === sku).length;
          const extraCount = qty - includedCount;
          let tag = '';
          if (includedCount > 0 && extraCount > 0) {
            tag = includedCount + '× inkl. + ' + extraCount + '× ' + formatEUR(item.price);
          } else if (includedCount > 0) {
            tag = includedCount + '× inkl.';
          } else {
            tag = extraCount + '× ' + formatEUR(item.price);
          }
          li.innerHTML = '<span>' + item.name + '</span><span class="kaubox-builder__summary-tag">' + tag + '</span>';
          summaryList.appendChild(li);
        });
      }

      addBtn.disabled = unitLog.length === 0;
      errorEl.hidden = true;
      successEl.hidden = true;
    }

    async function addToCart() {
      if (unitLog.length === 0) return;
      addBtn.disabled = true;
      addBtn.classList.add('loading');
      errorEl.hidden = true;
      successEl.hidden = true;

      const normalUnits = unitLog.filter((sku) => !catalogBySku[sku].premium);
      const premiumUnits = unitLog.filter((sku) => catalogBySku[sku].premium);
      const includedUnits = normalUnits.slice(0, baseSlots);
      const extraNormalUnits = normalUnits.slice(baseSlots);
      const chargedExtraUnits = extraNormalUnits.concat(premiumUnits);

      const includedCounts = {};
      includedUnits.forEach((sku) => (includedCounts[sku] = (includedCounts[sku] || 0) + 1));

      const extraCounts = {};
      chargedExtraUnits.forEach((sku) => (extraCounts[sku] = (extraCounts[sku] || 0) + 1));

      const bundleId = 'kb_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);

      const baseProperties = { _kaubox_bundle_id: bundleId };
      Object.keys(includedCounts).forEach((sku, i) => {
        baseProperties['Basis-Auswahl ' + (i + 1)] = catalogBySku[sku].name + (includedCounts[sku] > 1 ? ' x' + includedCounts[sku] : '');
      });
      if (Object.keys(extraCounts).length > 0) {
        baseProperties['Zusätze'] = Object.keys(extraCounts)
          .map((sku) => catalogBySku[sku].name + ' x' + extraCounts[sku])
          .join(', ');
      }

      const items = [
        {
          id: baseVariantId,
          quantity: 1,
          properties: baseProperties,
        },
      ];

      Object.keys(extraCounts).forEach((sku) => {
        items.push({
          id: catalogBySku[sku].variantId,
          quantity: extraCounts[sku],
          properties: { _kaubox_zusatz_fuer: 'KAUBOX Individual', _kaubox_bundle_id: bundleId },
        });
      });

      const cartEl = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      try {
        const body = {
          items: items,
        };
        if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
          body.sections = cartEl.getSectionsToRender().map((s) => s.id);
          body.sections_url = window.location.pathname;
        }

        const response = await fetch(window.routes ? window.routes.cart_add_url : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });

        const data = await response.json();

        if (!response.ok || data.status) {
          throw new Error((data.description || data.message || 'Fehler beim Hinzufügen zum Warenkorb'));
        }

        successEl.hidden = false;

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'kaubox-builder',
            cartData: data,
          });
        }

        if (cartEl && typeof cartEl.renderContents === 'function') {
          cartEl.renderContents(data);
        }

        // reset builder state after successful add
        unitLog = [];
        update();
      } catch (err) {
        errorEl.hidden = false;
        errorEl.textContent = err.message || 'Etwas ist schiefgelaufen. Bitte versuche es erneut.';
      } finally {
        addBtn.classList.remove('loading');
        addBtn.disabled = unitLog.length === 0;
      }
    }

    addBtn.addEventListener('click', addToCart);

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
